import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { authAction, recoveryPasswordAction } from "../../redux/actions";
import { RECOVERY_PASSWORD_FORM_INITIAL } from "../../redux/initialStateConstants";
import { recoveryPasswordSagaAction } from "../../redux/sagaActions";

const RecoverPassword = () => {
    const dispatch = useDispatch();

    const auth_form = useSelector(state => state.auth_form);
    const recovery_password_form = useSelector(state => state.recovery_password_form);

    return (
        <div className="form">
            <div className="form__mask"/>
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => {
                            dispatch(recoveryPasswordAction(RECOVERY_PASSWORD_FORM_INITIAL));
                            dispatch(authAction({
                                ...auth_form,
                                open: true
                            }));
                        } }/>
                        <div className="form__title">Восстановление пароля</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Почта, указанная при регистрации</div>
                        <input type="text" className="input"
                                value={ recovery_password_form.email }
                                onInput={ event => dispatch(recoveryPasswordAction({
                                    ...recovery_password_form,
                                    email: event.target.value
                                })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(recoveryPasswordSagaAction({
                                email: recovery_password_form.email
                            })) }
                        >Восстановить пароль</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecoverPassword;